<template>
  <div class="xxhdyx-main">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="品牌">
              <el-select v-model="searchForm.bid" clearable style="width: 120px">
                <el-option v-for="b in brandList" :label="b.brand_name" :value="b.brand_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="searchForm.mark" clearable style="width: 100px">
                <el-option label="未发布" :value="0"></el-option>
                <el-option label="已发布" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-plus" type="primary" @click="editRow(null)">添加活动</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" v-loading="loading">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%">
              <el-table-column
                label="封面图片"
                align="center"
                width="80">
                <template slot-scope="scope">
                  <el-image
                    :src="scope.row.imgurl"
                    fit="cover"
                    style="width: 40px;height: 40px;"
                    :preview-src-list="[scope.row.imgurl]">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column
                prop="brandname"
                label="品牌"
                width="120"
                align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="活动名称"
                min-width="160"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span style="font-weight: bold">{{scope.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="活动时间"
                width="200"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.starttime}}～{{scope.row.endtime}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="username"
                label="发布人"
                width="100"
                align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="time"
                label="发布时间"
                width="170"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="状态"
                width="100"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1">已发布</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="danger">未发布</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="200"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button icon="el-icon-edit" size="mini" @click="editRow(scope.row)">修改</el-button>
                  <el-button icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="dialogVisible"
      width="60%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
      :close-on-click-modal="false">
      <el-form ref="editForm" size="small" :model="editForm" label-width="80px" :rules="rules" style="padding:15px 30px 15px 15px;">
        <el-form-item label="品牌" prop="bid">
          <el-select v-model="editForm.bid" style="width: 200px">
            <el-option v-for="b in brandList" :label="b.brand_name" :value="b.brand_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动名称" prop="name">
          <el-input placeholder="请输入活动名称" show-word-limit maxlength="50" v-model="editForm.name"/>
        </el-form-item>
        <el-form-item label="活动日期" prop="time">
          <el-date-picker
            v-model="editForm.time"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="封面" prop="img">
          <span style="color:#99a9bf;"><i class="el-icon-warning"></i> 建议上传1:1正方形的图片</span>
          <SingleImg :key="imgKey" v-model="editForm.img" :oldurl="editForm.oldimgurl"/>
        </el-form-item>
        <el-form-item label="活动详情" prop="content">
          <tinymce ref="tinymce" :key="tinymceKey" v-model="editForm.content" :height="200" />
        </el-form-item>
        <el-form-item label="是否发布" prop="mark">
          <el-radio-group v-model="editForm.mark">
            <el-radio :label="0">不发布</el-radio>
            <el-radio :label="1">发布</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button :loading="eidtLoading" type="primary" @click="SubForm()">立即提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getBrandSeriesList, getBrandOfflineList, editBrandOffline, delBrandOffline } from '@/api/pub'
import SingleImg from '@/components/upload/SingleImg'
import tinymce from '@/components/Tinymce'
export default {
  name: "xxhdyx",
  computed: {
    user: getUser
  },
  components: {
    SingleImg,
    tinymce
  },
  data() {
    return {
      searchForm: {
        bid: null,
        mark: null,
        search: ''
      },
      brandList: [],
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editForm: {
        boid: 0,
        bid: null,
        name: '',
        time: [],
        img: null,
        content: '',
        mark: 0,
        oldimgurl: ''
      },
      rules: {
        bid: [{ required: true, message: '请选择品牌', trigger: 'change' }],
        name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        time: [{ required: true, message: '请选择起始时间与结束时间', trigger: 'change' }],
        img: [{ required: true, message: '请上传封面', trigger: 'change' }],
        content: [{ required: true, message: '请输入活动详情内容', trigger: 'blur' }]
      },
      editTitle: '',
      dialogVisible: false,
      eidtLoading: false,
      imgKey: '',
      tinymceKey: ''
    }
  },
  created() {
    getBrandSeriesList().then(response => {
      let _brandList = []
      if (this.user.dGroupid === 1) { // 杭州乔金斯
        for (const b of response.data) {
          if (b.brand_id === 3) {
            _brandList.push(b)
          }
        }
      } else if (this.user.dGroupid === 2) { // 耐思迪
        for (const b of response.data) {
          if (b.brand_id === 1 || b.brand_id === 2) {
            _brandList.push(b)
          }
        }
      }
      this.brandList = _brandList
    })
    this.getData()
  },
  methods: {
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        bid: this.searchForm.bid,
        mark: this.searchForm.mark,
        search: this.searchForm.search,
        groupid: this.user.dGroupid
      }
      getBrandOfflineList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    editRow(row) {
      if (row === null) {
        this.editTitle = '添加活动'
        this.editForm.boid = 0
        this.editForm.bid = null
        this.editForm.name = null
        this.editForm.time = []
        this.editForm.img = null
        this.editForm.oldimgurl = null
        this.editForm.content = null
        this.editForm.mark = 0
      } else {
        this.editTitle = '编辑活动'
        this.editForm.boid = row.boid
        this.editForm.bid = row.bid
        this.editForm.name = row.name
        var _time = []
        _time.push(row.starttime)
        _time.push(row.endtime)
        this.editForm.time = _time
        this.editForm.img = { imgid: row.imgid, imgurl: row.imgurl }
        this.editForm.oldimgurl = row.imgurl
        this.editForm.content = row.content
        this.editForm.mark = row.mark
      }
      this.imgKey = new Date().getTime().toString()
      this.tinymceKey = (new Date().getTime() + 2).toString()
      this.dialogVisible = true
    },
    SubForm() {
      if (!this.eidtLoading) {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.eidtLoading = true
            const data = {
              boid: this.editForm.boid,
              bid: this.editForm.bid,
              name: this.editForm.name,
              starttime: this.editForm.time[0],
              endtime: this.editForm.time[1],
              imgid: this.editForm.img.imgid,
              content: this.editForm.content,
              mark: this.editForm.mark,
              userid: this.user.dUserid
            }
            editBrandOffline(data).then(response => {
              this.eidtLoading = false
              this.$message({
                type: 'success',
                message: '提交成功'
              })
              this.Search()
              this.dialogVisible = false
            }).catch(() => {
              this.eidtLoading = false
            })
          }
        })
      }
    },
    deleteRow(row) {
      this.$confirm('您确定要删除此活动吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        delBrandOffline({ boid: row.boid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.xxhdyx-main{
}
</style>
